"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BasketStep = void 0;
var _checkoutBasket = require("@ori/checkout-basket");
var _contexts = require("../contexts");
var _CheckoutSummary = require("./CheckoutSummary");
var _jsxRuntime = require("react/jsx-runtime");
const BasketStep = () => {
  const configuration = (0, _contexts.useCheckout)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutBasket.CheckoutBasket, {
    ...(0, _checkoutBasket.getProps)({
      isSimplifiedCheckout: true,
      ...configuration
    }),
    checkoutSummary: _CheckoutSummary.CheckoutSummary
  });
};
exports.BasketStep = BasketStep;
var _default = exports.default = BasketStep;